// extracted by mini-css-extract-plugin
export default {"price_table":"plZvygRovmzA5olTNROw","priceTable":"plZvygRovmzA5olTNROw","price_table_supplement":"kiEkpFB_9m9HIfvYtwmG","priceTableSupplement":"kiEkpFB_9m9HIfvYtwmG"};